import { call, put, takeEvery, all } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import { fetchCandidatesByContactRoutine } from '../../routines';
import { getByContactId } from '../../../../services/contactService';

function* getCandidatesRequest({ payload }: Routine<any>) {
  try {
    const response = yield call(getByContactId, payload);
    yield put(fetchCandidatesByContactRoutine.success(response));
  } catch {
    yield put(fetchCandidatesByContactRoutine.failure());
  }
}

function* watchGetCandidatesRequest() {
  yield takeEvery(fetchCandidatesByContactRoutine.TRIGGER, getCandidatesRequest);
}

export default function* contactCandidatesSaga() {
  yield all([
    watchGetCandidatesRequest()
  ]);
}
